import { Navigate } from "react-router-dom";

/**
 * Contact route: since the printed banners & marketing materials all direct
 * to /signup, any landing on /contact funnels straight to the signup page.
 * This keeps "one conversion funnel" — no forked forms.
 */
export default function Contact() {
  return <Navigate to="/signup" replace/>;
}
